import { SvgIconProps } from '@mui/material';

import ChevronUpIcon from 'modules/common/components/Icons/ChevronUpIcon';

type Direction = 'up' | 'down' | 'right' | 'left';
type DirectionMapper = {
    [key in Direction]: number;
};

const fromDirectionMapper: DirectionMapper = {
    up: 0,
    down: 180,
    right: 90,
    left: -90,
};

export default function RotableChevron({
    from = 'down',
    to = 'up',
    isRotated,
    sx,
    ...props
}: SvgIconProps & {
    from?: Direction;
    to?: Direction;
    isRotated: boolean;
}) {
    const degNormal = fromDirectionMapper[from];
    const degIfRotated = fromDirectionMapper[to];

    return (
        <ChevronUpIcon
            sx={{
                ...sx,
                transform: `rotate(${isRotated ? degIfRotated : degNormal}deg)`,
                transition: 'transform 0.2s',
            }}
            {...props}
        />
    );
}
